export const OTP_STATUS = {
    NOT_STARTED: 'NOT_STARTED',
    REQUEST_STARTED: 'REQUEST_STARTED',
    REQUEST_SUCCESS: 'REQUEST_SUCCESS',
    FAILED_REQUEST: 'FAILED_REQUEST',
    FETCH_STARTED: 'FETCH_STARTED',
    FAILED_FETCH: 'FAILED_FETCH',
    SEND_STARTED: 'SEND_STARTED',
    FINISHED: 'FINISHED',
    FAILED_SEND: 'FAILED_SEND',
    REQUIRE_RESEND: 'REQUIRE_RESEND'
};
